import CreatePage from './CreatePage.container';
import EditPage from './EditPage.container';
import ListPage from './ListPage.container';

export default {
  CreatePage,
  EditPage,
  ListPage
};
